export default __webpack_public_path__ + "static/media/tab4.83179b6a.svg";